import { useQuery } from '@tanstack/react-query';

import { homeQuery } from '@/api/home/homeQuery';

import type { UseHomeQueryOptions } from './types';

export const useHomeQuery = (options?: UseHomeQueryOptions) => {
  const { shopId, brandId, limit, location, ...rest } = options ?? {};

  return useQuery({
    ...homeQuery({ shopId, brandId, limit, location }),
    placeholderData: (prevData) => prevData,
    ...rest,
  });
};
